import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import ElementPlus from "element-plus";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import locales from "./locales";
import "element-plus/dist/index.css";
import "./assets/styles.css";
import formatters from "@/plugins/formatters.js";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import CopyButton from "./components/CopyButton.vue";
import SingleImageUploader from "./components/SingleImageUploader.vue";

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: locales,
});

const app = createApp(App);
app.use(i18n);
app.use(ElementPlus);
app.use(createPinia());
app.use(router);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.component("CopyButton", CopyButton);
app.component("SingleImageUploader", SingleImageUploader);
app.use(formatters);
app.mount("#app");
